import React from "react";
import { Box, Typography, Container, Grid, Stack } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HandshakeIcon from "@mui/icons-material/Handshake";
import SpeedIcon from "@mui/icons-material/Speed";

// Mock data for trust pillars
const trustPillars = [
  {
    title: "شفافیت کامل مالی",
    desc: "بدون هزینه‌های پنهان. تمام جزئیات فنی و مالی در قرارداد روشن و قطعی است.",
    icon: <HandshakeIcon />,
  },
  {
    title: "تعهد به زمان تحویل",
    desc: "زمان شما طلاست. ما روی تاریخ تحویل پروژه‌ها وسواس و دیسیپلین سخت‌گیرانه‌ای داریم.",
    icon: <SpeedIcon />,
  },
  {
    title: "تضمین کیفیت و گارانتی",
    desc: "ارائه پشتیبانی فنی رایگان پس از تحویل پروژه برای اطمینان از عملکرد بی‌نقص سیستم.",
    icon: <CheckCircleOutlineIcon />,
  },
];

export default function WhyUs() {
  return (
    <Container maxWidth="xxl">
      <Box
        className="reveal-up"
        sx={{
          position: "relative",
          borderRadius: "32px",
          overflow: "hidden",
          p: { xs: 5, md: 8 },
          border: "1px solid rgba(255,255,255,0.08)",
          //   backdropFilter: "blur(4px)",
          mb: "5rem",
        }}
      >
        {/* Background glow decorative element */}
        <Box
          sx={{
            position: "absolute",
            top: "-50%",
            right: "-20%",
            width: "70%",
            height: "150%",
            background:
              "radial-gradient(ellipse at center, rgba(56,189,248,0.05) 0%, transparent 70%)",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        <Grid
          container
          spacing={8}
          sx={{ position: "relative", zIndex: 1 }}
          alignItems="center"
        >
          {/* Left Column: Heading and intro */}
          <Grid size={{ xs: 12, lg: 5 }}>
            <Typography
              sx={{
                color: "#38BDF8",
                fontSize: 14,
                letterSpacing: "2px",
                mb: 2,
                fontWeight: 700,
              }}
            >
              تفاوت ویـرا
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: 24, lg: 30 },
                fontWeight: 700,
                mb: 3,
                lineHeight: 1.3,
                color: "secondary.main",
              }}
            >
              چرا مدیران موفق با ما کار می‌کنند؟
            </Typography>
            <Typography
              sx={{ fontSize: {xs:14 , md:16}, color: "#94A3B8", lineHeight: 1.8 }}
            >
              ما می‌دانیم که بزرگترین دغدغه‌ی کارفرمایان، هزینه‌های پنهان، تاخیر
              در تحویل و رها شدن پروژه پس از تسویه‌حساب است. ما ساختار خود را به
              گونه‌ای بنا کرده‌ایم که این ریسک‌ها را به صفر برسانیم.
            </Typography>
          </Grid>

          {/* Right Column: Trust pillars list */}
          <Grid size={{ xs: 12, lg: 7 }}>
            <Stack spacing={5}>
              {trustPillars.map((pillar, idx) => (
                <Box key={idx} sx={{ display: "flex", gap: 3 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      bgcolor: "rgba(255,255,255,0.03)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      flexShrink: 0,
                    }}
                  >
                    {pillar.icon}
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: 700,
                        mb: 1,
                        color: "#F8FAFC",
                      }}
                    >
                      {pillar.title}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "1rem", color: "#94A3B8", lineHeight: 1.7 }}
                    >
                      {pillar.desc}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
